import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import CustomLoader from '../../../common/CustomLoader';
import Swal from 'sweetalert2';
import ConstructorFieldDetail from './ConstructorFieldDetail';
import showAlert from '../../../../common/utils/alert';

export default class ListConstructor extends Component {
  static propTypes = {
    constructors: PropTypes.array.isRequired,
    projectId: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
    collection: PropTypes.object.isRequired,
  };
  handleDelete = (constructorId) => {
    const { projectId, collection, version, actions, commonActions } = this.props;
    const { uuid, collectionName } = collection;
    const preConfirm = () => {
      actions.deleteConstructor({
        version,
        constructorId,
        projectId,
        collectionUuid: uuid,
      });
      commonActions.trackCollectionChange({ uuid: uuid });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  render() {
    const {
      constructors,
      showConstructorDeleteLoader,
      projectId,
      collection,
      actions,
      commonActions,
      version,
      deleteFlag,
    } = this.props;
    if (constructors && constructors.length > 0) {
      return (
        <div className="row modal-scroll">
          <div className="col-12">
            <ConstructorFieldDetail
              projectId={projectId}
              version={version}
              collection={collection}
              actions={actions}
              commonActions={commonActions}
              constructors={constructors}
              showConstructorDeleteLoader={showConstructorDeleteLoader}
              deleteFlag={deleteFlag}
            />
          </div>
        </div>
      );
    }
    return (
      <div>
        <h5 className="text-center">No Constructors! </h5>
      </div>
    );
  }
}
